import styles from "./styles/create.module.scss";
import { Box, Stack, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { Button, Icon, Image } from "ui";
import Routes from "data/routes";

export function CreateStory() {
  const router = useRouter();

  return (
    <Box className={styles.container}>
      <Stack spacing={2} justifyContent="center">
        <Stack spacing={1}>
          <Typography variant="h3">¿Qué aventura te imaginas?</Typography>
          <Typography variant="body1">
            Usa tus personajes favoritos para crear una nueva historia
            personalizada.
          </Typography>
        </Stack>
        <Button
          className={styles.create}
          onClick={() => router.push(Routes.create)}
          size="medium"
        >
          Crear
        </Button>
      </Stack>
      <Icon name="auto_awesome" />
      <Stack className={styles.image}>
        <Image
          alt="new-cloud"
          className={styles.cloud}
          loading="lazy"
          src="/assets/home/cloud.svg"
          height={225}
          width={400}
        />
        <Image
          alt="new-animals"
          loading="lazy"
          src="/assets/home/animals.svg"
          height={225}
          width={400}
        />
      </Stack>
    </Box>
  );
}
